import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a28da14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guide-popup-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "guide-popup-body"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        ($setup.shouldShowModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                onClick: $setup.handleClickClosebutton,
                "aria-label": "닫기"
              }, [
                _createVNode($setup["InlineSvg"], {
                  src: require('@/assets/icons/x-icon.svg')
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _createElementVNode("img", {
                src: require('@/assets/guides/losts/guide_lost_1.png'),
                "aria-hidden": "true",
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_3)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}